import { createStyle } from '@gluestack-style/react';

export const SelectActionsheetFlatList = createStyle({
  w: '$full',
  h: 'auto',
});
